import { render, staticRenderFns } from "./JoinRewardsForm.vue?vue&type=template&id=4c011958"
import script from "./JoinRewardsForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./JoinRewardsForm.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./JoinRewardsForm.vue?vue&type=style&index=0&id=4c011958&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports